import UpdateLocationModal from './UpdateLocationModal';

export default UpdateLocationModal;
